import { render, staticRenderFns } from "./ImageObjectDrawer.vue?vue&type=template&id=00f43fd4&"
import script from "./ImageObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./ImageObjectDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports